import React from 'react';
import { NavLink } from 'react-router-dom';
import { House, MapTrifold, Tree, ChatCircleText, CloudArrowUp } from '@phosphor-icons/react';

const items = [
  { to: '/', label: 'Home', Icon: House, testid: 'nav-home' },
  { to: '/map', label: 'Map', Icon: MapTrifold, testid: 'nav-map' },
  { to: '/inspect', label: 'Inspect', Icon: Tree, testid: 'nav-inspect' },
  { to: '/assistant', label: 'AI', Icon: ChatCircleText, testid: 'nav-assistant' },
  { to: '/sync', label: 'Sync', Icon: CloudArrowUp, testid: 'nav-sync' },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-canvas border-t-2 border-carbon z-40"
    >
      <ul className="grid grid-cols-5">
        {items.map(({ to, label, Icon, testid }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={to === '/'}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2 min-h-[56px] gap-0.5 ${
                  isActive ? 'bg-carbon text-canvas' : 'text-carbon hover:bg-surface-alt'
                }`
              }
            >
              <Icon size={22} weight="bold" />
              <span className="font-display text-[10px] font-bold uppercase tracking-widest">
                {label}
              </span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
